module.exports = __webpack_public_path__ + "img/thumb-tradycyjni-europejczycy.jpg";